<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="int1" style="margin-left: 17px">
        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
        <br />
        <span class="txt">
          1. Ancillaries selected here will be displayed on the front end.

        </span>
        <br />
        <span class="txt">
          2. Ancillaries not selected here will be suppressed on the front end only for the selected platform. </span>
        <br />
        <span class="txt">
          3. Rule once created can not be edited for all fields except status.
        </span>
      </div>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" (click)="checkData()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">

                  <div class="col-lg-12 rowspace">

                    <div class="col-lg-4">
                      <label>Platform</label>
                      <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="screen_details.midName"
                        (change)="clearmidname()" [disabled]="editFlag">
                        <option disabled value="0">Select Platform</option>
                        <ng-container *ngFor="let combo of midType;">
                          <option *ngIf="(combo.MID_NAME != 'COBUBA')" value="{{combo.ID}}">{{combo.MID_NAME}}</option>
                        </ng-container>

                      </select>
                      <span *ngIf="midname" style="color: red"> Please Select Platform </span>
                    </div>
                    <div class="col-lg-4">
                      <label>Form Factor</label>
                      <div>
                        <ng-multiselect-dropdown-angular7 placeholder="Select Platform"
                          [settings]="dropdownPlatformSettings" [data]="platformData"
                          [(ngModel)]="screen_details.platform" (onSelect)="onPlatFormSelect($event)"
                          (onSelectAll)="onPlatFormSelectAll($event)" [disabled]="editFlag">
                        </ng-multiselect-dropdown-angular7>
                        <span *ngIf="formFactorType" style="color: red"> Please Select Form Factor</span>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <label>Travel Type</label>
                      <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="screen_details.travelType"
                        (change)="cleartraveltype()" [disabled]="editFlag">
                        <option disabled value="0">Select Travel Type</option>
                        <option value="3">Both</option>
                        <option value="1">Domestic</option>
                        <option value="2">International</option>
                      </select>
                      <span *ngIf="traveltype" style="color: red"> Please Select Travel Type </span>
                    </div>


                  </div>

                  <div class="col-lg-12 rowspace">
                    <div class="col-lg-4">
                      <label>Select Ancillaries to display</label>
                      <div>
                        <ng-multiselect-dropdown-angular7 placeholder="Select Ancillaries to display"
                          [settings]="dropdownSettings" [data]="ancillariesDataUba"
                          [(ngModel)]="screen_details.selectedAncillaries" (onSelect)="onItemSelect($event)"
                          (onSelectAll)="onSelectAll($event)" [disabled]="editFlag">
                        </ng-multiselect-dropdown-angular7>
                        <span *ngIf="ancillariestype" style="color: red"> Please Select Ancillaries to display</span>
                      </div>
                    </div>

                    <div class="col-lg-12 rowspace">
                      <div style="margin-top: 10px;">
                        <label>Status</label><br>
                        Active <input type="radio" [(ngModel)]="activeStatus" value="1" id="_11" name="type" checked>
                        Inactive <input type="radio" [(ngModel)]="activeStatus" value="0" id="_11" name="type">

                        <span *ngIf="statusvalue" style="color: red"> Please Select Status </span>

                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>{{ screentitle }}</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div>
                    <div class="btn clear-button button-margin">
                      <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                        type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>

                    <div class="col-lg-4">
                      <label>Ancillaries Type</label>
                      <input [(ngModel)]="ancillariesName" type="text" class="form-control m-input"
                        placeholder="Enter Ancillaries Name" />
                    </div>
                  </div>
                  <br />

                  <div *ngIf="searchlist" class="reportstatus">
                    <table aria-describedby="hideAncillariesData" class="table table-striped" [mfData]="serachtabledata"
                      [mfRowsOnPage]="6">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 10%">Actions</th>

                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Travel Type</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Ancillaries Type</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Platform</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Form Factor</mfDefaultSorter>
                          </th>
                          <th scope="col" style="width: 20%">
                            <mfDefaultSorter by="email">Status</mfDefaultSorter>
                          </th>

                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let obj of (searchRecord   | paginate: { itemsPerPage: 10, currentPage: p })">
                          <td>

                            <button class="btn btn-default btn-circle" type="button" (click)="showFormData(obj,1)"
                              data-toggle="modal" data-target="#myModal2">
                              <em class="fa fa-eye"></em>
                            </button>

                            <button class="btn btn-default btn-circle" type="button" (click)="
                              showFormData(obj,2)
                            ">
                              <em class="fa fa-pencil"></em>
                            </button>


                          </td>
                          <td>{{obj.TRAVEL_NAME}}</td>
                          <td>{{obj.SSR_TYPE}}</td>
                          <td>{{obj.MID_NAME}}</td>
                          <td>{{obj.FORM_FACTOR_CATEGORY}}</td>
                          <td *ngIf="obj.IS_ACTIVE==1">Active</td>
                          <td *ngIf="obj.IS_ACTIVE==0">Inactive</td>
                        </tr>

                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="6">
                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                          </td>
                        </tr>
                      </tfoot>

                    </table>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


<div class="modal" id="myModal2">
  <div class="modal-dialog" style="width: 800px;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">View Ancillaries
          <button class="modal-title" type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </h4>
      </div>
      <div class="modal-body">
        <div>
          <table aria-describedby="hideAncillariesFormFactorData" style="margin:auto">

            <body style="background-color: #fff;">
              <ng-container *ngFor="let vw of viewRecord;let i=index">
                <ng-container *ngIf="i==0">
                  <tr style="border-bottom: 1px solid #cebbbb;">
                    <th scope="col">Form Factor:</th>
                    <td>{{vw.FORM_FACTOR_CATEGORY}}</td>
                  </tr>


                  <tr style="border-bottom: 1px solid #ad9f9f;">
                    <th scope="col">Platform:</th>
                    <td>{{vw.MID_NAME}}</td>
                  </tr>

                  <tr style="border-bottom: 1px solid #ad9f9f;">
                    <th scope="col">Travel Type:</th>
                    <td>{{vw.TRAVEL_NAME}}</td>
                  </tr>

                  <tr style="border-bottom: 1px solid #ad9f9f;">
                    <th scope="col">Ancillaries Type:</th>
                    <td>{{vw.SSR_TYPE}}</td>
                  </tr>

                  <tr style="border-bottom: 1px solid #ad9f9f;">
                    <th scope="col">Status:</th>
                    <td *ngIf="vw.IS_ACTIVE==1">Active</td>
                    <td *ngIf="vw.IS_ACTIVE==0">InActive</td>
                  </tr>
                </ng-container>
              </ng-container>
            </body>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<button id="openModalButton" [hidden]="true" data-toggle="modal" data-target="#insertAncillaries">Open Modal</button>
<div class="modal fade" id="insertAncillaries" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content" style="margin: 0 auto;width: 566px;">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">This action will over ride the existing rule in the system. Do you still want to
          proceed?</h4>
      </div>
      <div class="modal-body">
        <div class="inner-pnr">
          <span>Enable/Disable Ancillaries</span>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" (click)="submitdata()" class="btn btn-default" data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>